import { Pagination as PaginationBar } from 'antd';
import { useTranslation } from 'react-i18next';
import {
	ApplicationSummary,
	ApplicationSummaryList,
	PagingConfig,
} from '../../../shared/VolunteerApplicationServiceTypes';
import isEmpty from 'lodash/isEmpty';
import { DashboardTable } from './DashboardTable';
import { DashboardSummaryCard } from './DashboardSummaryCard';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';
import EmptyList from '../../../components/EmptyList';

export const DashboardList = ({
	data: { applicationSummary: applications, pagination },
	onPageChange,
	onEvaluateClick,
	onVerifyResultsClick,
	pageConfig,
	overAllCandidateStatus,
	isZCUnpublishedRecords,
}: {
	data: ApplicationSummaryList;
	onPageChange: (page: number, pageSize: number) => void;
	onEvaluateClick: (application: ApplicationSummary) => void;
	onVerifyResultsClick: (application: ApplicationSummary) => void;
	pageConfig: PagingConfig;
	overAllCandidateStatus: boolean;
	isZCUnpublishedRecords: boolean;
}) => {
	const { t } = useTranslation();
	if (
		isEmpty(pagination.totalNoOfRecords) ||
		pagination.totalNoOfRecords === 0
	) {
		return (
			<EmptyList
				message={
					isZCUnpublishedRecords
						? t('isZCRecordsareInPastDateMessage')
						: t('noApplications')
				}
			/>
		);
	}

	const dashboardCards = applications?.map((application) => (
		<div className="mb-[16px]" key={application.applicationId}>
			<DashboardSummaryCard
				{...application}
				onEvaluateClick={onEvaluateClick}
				onVerifyResultsClick={onVerifyResultsClick}
				isOverAllCandidatesStatus={overAllCandidateStatus}
			/>
		</div>
	));

	return (
		<div className="flex flex-col gap-6">
			<div className="sm:hidden">
				{dashboardCards}
				<div className="flex justify-center w-full">
					<PaginationBar
						current={pageConfig.pageNo ?? 1}
						total={pagination.totalNoOfRecords}
						defaultPageSize={pageConfig.pageSize ?? DEFAULT_PAGE_SIZE}
						onChange={onPageChange}
					/>
				</div>
			</div>
			<div className="hidden sm:block">
				<DashboardTable
					applications={applications}
					onEvaluateClick={onEvaluateClick}
					onVerifyResultsClick={onVerifyResultsClick}
					pagination={pagination}
					onPageChange={onPageChange}
					pageConfig={pageConfig}
				/>
			</div>
		</div>
	);
};
